import React, { useEffect, useState } from 'react';

import {
  ScheduleContainer,
  TopSection,
  BottomSection,
  LeftSection1,
  LeftSection2,
  RightSection,
} from '../styles';

import { Appointments, Spinner, ImageCardComponent, CalendarComponent, SelectedDatesComponent } from '../components';

import { getUserBooking, getBookings } from '../api';

const Schedule = () => {
  const [appointments, setAppointments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedDate, setSelectedDate] = useState();
  const [allDates, setAllDates] = useState([]);
  const [availableDates, setAvailableDates] = useState([]);
  const [occupiedDates, setOccupiedDates] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const fetchScheduleData = async () => {
      try {

        // Requisição para buscar agendamentos do usuário
        const responseBookings = await getBookings();

        if (!responseBookings.ok) {
          throw new Error('Erro ao buscar agendamentos.');
        }

        const dataBookings = await responseBookings.json();

        const dates = dataBookings.dates || [];

        const available = [];
        const occupied = [];

        // Itera sobre cada data para verificar a disponibilidade
        dates.forEach(dateEntry => {
          const date = dateEntry.date;
          const availableTimes = dateEntry.available || [];

          // Se o array available não está vazio, adiciona à lista de datas disponíveis
          if (availableTimes.length > 0) {
            available.push(date);

          } else {
            // Se o array available está vazio, adiciona à lista de datas ocupadas
            occupied.push(date);
          }
        });

        setAllDates(dates);
        setAvailableDates(available);
        setOccupiedDates(occupied);

        const responseAppointment = await getUserBooking();

        if (!responseAppointment.ok) {
          throw new Error(`Erro ao buscar agendamentos: ${responseAppointment.status} ${responseAppointment.statusText}`);
        }

        const data = await responseAppointment.json();

        // Transformar os dados no formato desejado
        const booking = Object.entries(data.userBookings).flatMap(([date, bookings]) =>
          bookings.map(booking => {
            const [year, month, day] = date.split('-');
            const formattedDate = `${day}/${month}/${year}`;

            // Converter priorityExpiration para dd-mm-aaaa
            const convertToDate = (datetime) => {
              if (!datetime) return null;
              const date = new Date(datetime);
              return `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`;
            };

            return {
              id: booking.bookingId,
              date: formattedDate,
              start_time: booking.startTime,
              end_time: booking.endTime,
              type: booking.type,
              invitedUsers: booking.invitedUsers,
              status: booking.status || null,
              priorityExpiration: convertToDate(booking.priorityExpiration), // Formata a data sem GMT
            };
          })
        );

        setAppointments(booking);

      } catch (error) {
        console.error('Erro ao buscar dados do agendamento:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchScheduleData();
  }, []);

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  if (loading) {
    return <Spinner />;
  }

  return (
    <ScheduleContainer>
      <TopSection>
        <LeftSection1>
          <Appointments appointments={appointments} />
        </LeftSection1>
        <RightSection>
          <ImageCardComponent />
        </RightSection>
      </TopSection>
      <BottomSection>
        <LeftSection2>
          {isMobile && (
            <CalendarComponent availableDates={availableDates} occupiedDates={occupiedDates} setSelected={handleDateChange} />
          )}
          {!isMobile && (
            <SelectedDatesComponent bookings={allDates} selectedDate={selectedDate} />
          )}
        </LeftSection2>
          {!isMobile && (
            <RightSection>
              <CalendarComponent availableDates={availableDates} occupiedDates={occupiedDates} setSelected={handleDateChange} />
            </RightSection>
          )}
          {isMobile && (
            <RightSection>
              <SelectedDatesComponent bookings={allDates} selectedDate={selectedDate} />
            </RightSection>
          )}
      </BottomSection>
    </ScheduleContainer>
  );
};

export default Schedule;
